// extracted by mini-css-extract-plugin
export default {"productGallery":"ZH-z","inQuickShop":"_H-z"};